// The MCO stress control — label, live value readout, slider, optional deviation caption.
// Shared by the Calculator and ECO / MCO Scenario Comparison tabs so both stress the season
// with the same control.

import { Box, Slider, Stack, Typography } from "@mui/material";

export default function StressSlider({ label, valueLabel, min, max, step, value, onChange, caption, captionOff }) {
  const lo = Number(min);
  const hi = Number(max);
  const safeMin = Number.isFinite(lo) ? lo : 0;
  const safeMax = Number.isFinite(hi) && hi > safeMin ? hi : safeMin + 1;
  const raw = Number(value);
  const safeValue = Number.isFinite(raw) ? Math.min(safeMax, Math.max(safeMin, raw)) : safeMin;

  return (
    <Box sx={{ minWidth: 180, flex: "1 1 180px" }}>
      <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="body2" fontWeight={600} sx={{ fontVariantNumeric: "tabular-nums" }}>
          {valueLabel}
        </Typography>
      </Stack>
      <Slider
        min={safeMin}
        max={safeMax}
        step={step}
        value={safeValue}
        onChange={(_, v) => onChange(v)}
        valueLabelDisplay="off"
        aria-label={label}
        sx={{
          // Override global mui/slider.css progress-bar look: trough + round knob.
          height: 6,
          padding: "14px 0 !important",
          clipPath: "none !important",
          color: "primary.main",
          "& .MuiSlider-rail": {
            display: "block !important",
            opacity: "1 !important",
            height: "6px !important",
            borderRadius: "3px !important",
            backgroundColor: "#d0d5dd !important",
          },
          "& .MuiSlider-track": {
            display: "block !important",
            height: "6px !important",
            border: "none !important",
            borderRadius: "3px !important",
          },
          "& .MuiSlider-thumb": {
            width: "18px !important",
            height: "18px !important",
            marginLeft: "0 !important",
            borderRadius: "50% !important",
            backgroundColor: "currentColor !important",
            border: "2px solid #fff !important",
            boxShadow: "0 1px 3px rgba(0,0,0,0.28) !important",
            "&::before, &::after": {
              display: "none !important",
            },
          },
        }}
      />
      {caption != null && (
        <Typography
          variant="caption"
          sx={{ display: "block", minHeight: 18, color: captionOff ? "#8a4a3a" : "#8a929b" }}
        >
          {caption}
        </Typography>
      )}
    </Box>
  );
}
